module.exports = __webpack_public_path__ + "static/media/05cuh.625ba46c.png";